import React from 'react';
import { compose } from 'redux';
import classNames from 'classnames';
import { } from 'react-router-dom';
import { connect } from 'react-redux';
import { withViewport } from '../../utils/contextHelpers.jsx';
import {
  // NamedLink,
  TopbarDesktop,
} from '..';
import { logout } from '../../actions';

import './Topbar.global.scss';

interface Props {
  className?: string,
  rootClassName?: string,
  desktopClassName?: string,
  isAuthenticated: boolean,
  logoutAction: any;
  // These are passed from Page to keep Topbar rendering aware of location changes
  // from injectIntl
  // intl: any,
}

export const TopbarComponent = (props: Props) => {
  const {
    className,
    rootClassName,
    desktopClassName,
    isAuthenticated,
    // intl,
    logoutAction,
  } = props;
  const classes = classNames(rootClassName || 'topbar', className);

  return (
    <div className={classes}>
      <div className="admin-shared-topbar">
        <TopbarDesktop
          className={desktopClassName}
          isAuthenticated={isAuthenticated}
          // notificationCount={notificationCount}
          logoutAction={logoutAction}
        />
      </div>
    </div>
  );
};


const mapStateToProps = (state: any) => ({
  auth: state.auth,
});

const mapDispatchToProps = (dispatch: any) => ({
  logoutAction: () => dispatch(logout()),
});

const Topbar = compose(
  withViewport,
  // injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(TopbarComponent);

Topbar.displayName = 'Topbar';

export default Topbar;
